import React, { useState, useRef, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BsPerson, BsTelephone, BsEnvelope, BsGeoAlt, BsArrowRightShort, BsPhone } from "react-icons/bs";
import Button from './Button';
import { ModalContext } from '../context/ModalContext';
import axiosInstance from '../axiosInstance';

function EnquiryForm(props){
  const [contactData, setContactData] = useState([]);
    useEffect(() => {
      const fetchData = async () => {
          try {
              const res = await axiosInstance.get("/api/fetchcontactnew"); // Adjust port if needed
              const fetchedData = res.data; // Assuming data is an array
              setContactData(fetchedData[0]);
          } catch (err) {
              console.error("Error fetching data:", err);
          }
      };
      fetchData();
    }, []);

  const { setShowEnquiryPopup } = useContext(ModalContext);
  const nameRef = useRef(null);
  const phoneRef = useRef(null);
  const emailRef = useRef(null);
  const messageRef = useRef(null);

  const[inputValue, setInputValue] = useState({
    name : '',
    phone : '',
    email : '',
    message : ''
  });
  const [errors, setErrors] = useState({});
  const [successMsg, setSuccessMsg] = useState('');

  const changeHandler = (e) => {
      const { name, value } = e.target;
      setInputValue((prevValues) => ({
        ...prevValues,
        [name]: value,
      }));
  };

  const validate = () => {
    const newErrors = {};
    if (!inputValue.name.trim()) newErrors.name = 'Name is required';
    if (!inputValue.phone.trim()) newErrors.phone = 'Phone is required';
    else if (!/^\d{10}$/.test(inputValue.phone.trim())) newErrors.phone = 'Enter valid 10 digit mobile number.';
    if (!inputValue.email.trim()) newErrors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(inputValue.email)) newErrors.email = 'Invalid email. Please Enter valid emailid.';
    
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      alert(Object.values(validationErrors).join("\n"));
      setErrors(validationErrors);
      // focus on first invalid field
      if (validationErrors.name) nameRef.current.focus();
      else if (validationErrors.phone) phoneRef.current.focus();
      else if (validationErrors.email) emailRef.current.focus();
      else if (validationErrors.message) messageRef.current.focus();
      return;
    }
    try {
      const res = await fetch('/api/enquiry', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(inputValue),
      });

      const data = await res.json();
      if (res.ok && data.success) {
        alert("Thanks! We'll get in touch soon.");
        setInputValue({ name: '', phone: '', email: '', message: '' });
        setErrors({});
        setShowEnquiryPopup(false);
      } else {
        alert(data.error || 'Submission failed');
      }
    } catch (err) {
      console.error('Error submitting form:', err);
      alert('Something went wrong. Please try again later.');
    }
  };

  return(
    <section className="home-form h-full w-full">
      <form className="flex items-center h-fit" onSubmit={handleSubmit}>
        <div className={`form-wrapper shadow-lg z-10 w-full text-base text-gray-800 ${props.title === 'Express Your Interest' ? 'rounded-none' : 'rounded-xl' } ${props.title === 'Express Your Interest' ? 'bg-transparent px-8 py-9' : props.title === '' ? 'bg-white px-8 py-9' : 'bg-slate-950 px-4 py-4'} grid grid-cols-1 gap-4`}>
          <h2 className={`form-heading ${props.title === 'Express Your Interest' ? 'text-center text-xl' : props.title === '' ? 'text-3xl' : 'text-xl'} font-thin`}>{props.title === '' ? <><span className='text-slate-500'>Get your</span> <span className='font-semibold'>Dream House</span></> : 
          <span className='font-semibold text-white'>{props.title}</span>
          }</h2>
          {props.title === '' ? <p className='form-content text-gray-700 mb-4'>Get in touch with us and our experts and developers would love to contribute their expertise and insights and help you today.</p> : '' }
          <div className='flex flex-col gap-4'>
            <div className={`grid grid-cols-1 ${props.title === '' ? 'md:grid-cols-2' : 'md-grid-cols-1'} gap-4 md:gap-2 lg:gap-4`}>
              <div className='relative flex'>
                <div className='absolute inset-y-0 right-0 flex items-center pr-2 pl-1 pointer-events-none text-slate-400'>
                  <BsPerson />
                </div>
                <input type="text" name="name" ref={nameRef} value={inputValue.name} placeholder="Name" autoComplete='off' required className={`grow border-solid border pl-2 pr-7 w-full ${props.title === '' ? 'border-slate-400 py-2': 'border-transparent py-1' }`} onChange={changeHandler} />
              </div>
              <div className='relative flex'>
                <div className='absolute inset-y-0 right-0 flex items-center pr-2 pl-1 pointer-events-none text-slate-400'>
                  <BsTelephone />
                </div>
                <input type="text" name="phone" ref={phoneRef} value={inputValue.phone} placeholder="Mobile" autoComplete='off' required maxLength={10} className={`grow border-solid border pl-2 pr-7 w-full ${props.title === '' ? 'border-slate-400 py-2': 'border-transparent py-1' }`} onChange={changeHandler} />  
              </div>  
              <div className={`relative flex ${props.title === '' ? 'md:col-span-2' : ''}`}>
                <div className='absolute inset-y-0 right-0 flex items-center pr-2 pl-1 pointer-events-none text-slate-400'>
                  <BsEnvelope />
                </div>           
                <input type="email" name="email" ref={emailRef} value={inputValue.email} placeholder="E-mail" autoComplete='off' required className={`grow border-solid border pl-2 pr-7 w-full ${props.title === '' ? 'border-slate-400 py-2': 'border-transparent py-1' }`} onChange={changeHandler} />
              </div>
              {props.title === 'Express Your Interest' ? '' :
              <div className={`relative flex ${props.title === '' ? 'md:col-span-2' : ''}`}>
                <textarea name="message" ref={messageRef} rows={props.title === '' ? 6 : 3} placeholder='Message' onChange={changeHandler} className={`grow border-solid border pl-2 pr-3 w-full ${props.title === '' ? 'border-slate-400 py-2': 'border-transparent py-1' }`} value={inputValue.message}></textarea>
              </div>
              }
            </div>                
            <div className={`enquiry-btn flex ${props.title === 'Express Your Interest' ? 'justify-center' : 'justify-start'}`}>
              <Button type='submit' variant='primary' id='submit' className='hover:bg-sky-950 w-full'>Send Email <BsArrowRightShort className='ml-3 text-2xl' /></Button>
            </div>
          </div>
          {props.title === 'Express Your Interest' ? 
            <div className='flex flex-col gap-3 justify-center py-3'>
              <h2 className='form-heading text-center text-xl font-semibold text-white'>REQUEST A CALL BACK</h2>
              <div className='flex flex-row text-base md:text-xl items-center bg-yellow-200 rounded-md overflow-hidden box-shadow hover:bg-yellow-300'>
                <span className='text-xl md:text-2xl px-3 py-2 bg-gray-600 text-white'><BsPhone /></span>
                {contactData?.mobile?.length > 0 && (
                <Link to={`tel:+91${contactData.mobile[0]}`} className='px-4 py-1 text-slate-950 font-medium grow hover'>+91 {contactData.mobile[0]}</Link>
                )}
              </div>
            </div>
          : '' 
          }
        </div>
      </form>   
    </section>
  );
}

export default EnquiryForm;
